import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import * as i18n from "util/i18n";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import { ResponsiveHeader } from "pages/_components/header";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import Notification from "pages/_components/Notification";
import { actions as echeckActions } from "reducers/echecks";
import { useTransaction } from "hooks/useTransactions";
import { connect, useDispatch } from "react-redux";
import { bool } from "prop-types";
import TransactionBody from "./components/TransactionBody";

const AcceptReturnTransactionPage = ({ isDesktop }) => {
    const dispatch = useDispatch();
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const confirmRoute = `/echecks/rejected/return/accept`;

    const formatTransactionEcheck = (data, idTransaction) => {
        const echeqData = {
            idTransaction,
            cancelTransaction: false,
            echeq: {
                cheque_id: data.idEcheq,
                fecha_pago: data.fechaPago,
                emisor_moneda: data.curency,
                cheque_numero: data.numeroEcheq,
                monto: data.montoTotal,
                cheque_caracter: data.caracter,
                estado: data.estado,
                tenencia_beneficiario_documento: data.tenenciaBeneficiarioDocumento,
                tenencia_beneficiario_documento_tipo: data.tenenciaBeneficiarioDocumentoTipo,
                tenencia_beneficiario_nombre: data.tenenciaBeneficiarioNombre,
                endosos: data.endosos,
            },
        };

        return { ...echeqData };
    };

    const { isLoading, transaction, handleSignTransaction, showSignButton, push, id, status } = useTransaction(
        confirmRoute,
        echeckActions.setEchecksToDoActions,
        echeckActions.cleanEcheckTicket,
        formatTransactionEcheck,
    );

    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "accept.return.rejected.echeq",
        id,
        "/echecks/action/transaction",
    );

    const { isBackoffice, isFinished, isPending, isFailed, isCancelled } = status;

    const cancelTransaction = () => {
        const { data, idTransaction } = transaction;
        const echeqData = {
            idTransaction,
            cancelTransaction: true,
            echeq: {
                cheque_id: data.idEcheq,
                fecha_pago: data.fechaPago,
                emisor_moneda: data.curency,
                cheque_numero: data.numeroEcheq,
                monto: data.montoTotal,
                cheque_caracter: data.caracter,
                estado: data.estado,
                endosos: data.endosos,
            },
        };

        dispatch(echeckActions.setEchecksToDoActions(echeqData));
        dispatch(echeckActions.cleanEcheckTicket()); // para evitar problemas de redireccionamiento del hook useConfirmTransaction en SummaryPage
        dispatch(push(confirmRoute));
    };

    const isReady = !isLoading;

    const renderBackToHomeButton = (isPrimary, offset) => (
        <Col xs={12} md={4} mdOffset={offset}>
            <Button
                onClick={() => dispatch(push("/desktop"))}
                label="forms.transaction.ticket.actions.backToHome"
                className={`btn${!isPrimary ? " btn-outline" : " btn-primary"}`}
            />
        </Col>
    );
    const renderDownloadButton = (isPrimary, offset) => (
        <Col xs={12} md={4} mdOffset={offset}>
            <Button
                onClick={handlePrint}
                image="images/figma/icon/download.svg"
                label="global.download"
                className={`btn${!isPrimary ? " btn-outline" : " btn-primary"}`}
            />
        </Col>
    );
    const renderCancelButton = (isPrimary, offset) => (
        <Col xs={12} md={4} mdOffset={offset}>
            <Button
                onClick={cancelTransaction}
                label="lotPayment.cancel"
                className={`btn${!isPrimary ? " btn-outline" : " btn-primary"}`}
            />
        </Col>
    );

    const renderSignButton = (isPrimary, offset) => (
        <Col xs={12} md={4} mdOffset={offset}>
            <Button
                onClick={handleSignTransaction}
                label="forms.signTransaction.link"
                className={`btn${!isPrimary ? " btn-outline" : " btn-primary"}`}
            />
        </Col>
    );

    return (
        <>
            <Notification scopeToShow="/echecks/action/transaction" />
            {!isBackoffice && <ResponsiveHeader ticket metaTitle="echeq.accept.return" />}
            <MainContainer showLoader={!isReady}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title="echeq.accept.return" />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <TransactionBody
                                        isTicket
                                        isDesktop={isDesktop}
                                        setShowMoreData={setShowMoreData}
                                        showMoreData={showMoreData}
                                    />
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            {isCancelled && renderBackToHomeButton(false, 4)}
                            {(isFinished || isFailed) && (
                                <>
                                    {renderBackToHomeButton(false, 2)}
                                    {renderDownloadButton(true, 0)}
                                </>
                            )}
                            {isPending &&
                                (showSignButton ? (
                                    <>
                                        {renderCancelButton(false, 2)}
                                        {renderSignButton(true, 0)}
                                    </>
                                ) : (
                                    <>
                                        {renderBackToHomeButton(false, 2)}
                                        {renderCancelButton(true, 0)}
                                    </>
                                ))}
                            {isFinished && !isDesktop && (
                                <Col xs={12} md={4}>
                                    <Button
                                        className="btn btn-outline"
                                        image="images/figma/icon/share.svg"
                                        label="global.share"
                                        onClick={() => {
                                            handleShareMobile();
                                        }}
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

AcceptReturnTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

const mapStateToProps = () => {};

export default connect(mapStateToProps)(AcceptReturnTransactionPage);
